import { z } from 'zod';

import { pageMetaSchema, type PageResult } from '@/lib/query/page';

const snapshotSchema = z.record(z.string(), z.unknown()).nullable().optional();

const auditRowSchema = z.object({
  id: z.string(),
  eventType: z.string().optional(),
  action: z.string().optional(),
  actorId: z.string().optional(),
  actorName: z.string(),
  actorIp: z.string().nullable().optional(),
  targetType: z.string().nullable().optional(),
  targetId: z.string().nullable().optional(),
  agencySlug: z.string().nullable().optional(),
  reason: z.string().nullable().optional(),
  before: snapshotSchema,
  after: snapshotSchema,
  metadata: snapshotSchema,
  createdAt: z.string(),
}).transform((row) => ({
  id: row.id,
  eventType: row.eventType ?? row.action ?? 'unknown',
  actorId: row.actorId ?? '',
  actorName: row.actorName,
  actorIp: row.actorIp ?? null,
  targetType: row.targetType ?? null,
  targetId: row.targetId ?? null,
  agencySlug: row.agencySlug ?? null,
  reason: row.reason ?? null,
  before: row.before ?? null,
  after: row.after ?? null,
  metadata: row.metadata ?? null,
  createdAt: row.createdAt,
}));

export type AuditRow = z.infer<typeof auditRowSchema>;

export function parseAuditRows(payload: unknown): AuditRow[] {
  const parsed = z.object({ audits: z.array(auditRowSchema) }).safeParse(payload);
  if (!parsed.success) throw new Error('The audit could not be read.');
  return parsed.data.audits;
}

export function parseAuditPage(payload: unknown): PageResult<AuditRow> {
  const parsed = z.object({ audits: z.array(auditRowSchema), meta: pageMetaSchema }).safeParse(payload);
  if (!parsed.success) throw new Error('The audit could not be read.');
  return { data: parsed.data.audits, meta: parsed.data.meta };
}
